import { Data, TeamGameMatchDataDisplay, TotalsPoints } from '../../../database.schema';
import { getTeamTotalsByDay, getTeamGamesByMatch } from '../../utils/totals-by-day-calculator';
import { useFetchData } from '../tournament-data';

export type Points = {
  team1Points: number;
  team2Points: number;
};

export type DisplayMatchResult = {
  team1Players: Array<string>;
  team2Players: Array<string>;
  result: string;
  margin?: string;
  hasScoreCardData: boolean;
};

export type TotalsPointsWithMatchResults = {
  courseName: string;
  courseId: number;
  startingHole: number;
  format: string;
  totals: TotalsPoints;
  matchResults: Array<DisplayMatchResult>;
  teamPoints: Points;
  teamRunningTotalPoints: Points;
  isArchivedTournament: boolean;
};

export const useFetchTeamTotalsByDay = (selectedIndex: number) => {
  return useFetchData((data: Data) => {
    return getTeamTotalsByDay(data, selectedIndex);
  });
};

export const useFetchTeamGameResultsByDay = (selectedIndex: number) => {
  return useFetchData((data: Data): Array<TeamGameMatchDataDisplay> => {
    return getTeamGamesByMatch(data, selectedIndex);
  });
};
